var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { attrs: { md12: "", layout: "", "justify-center": "", "my-5": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs11: "", sm8: "", md5: "", xl4: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Buscar...",
                  "append-icon": "search",
                  clearable: ""
                },
                on: { input: _vm.handleFilter },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "modal-options__layout" },
        [
          _vm._l(_vm.dataFilter, function(item) {
            return _c("div", { key: item.idopcion, staticClass: "card" }, [
              _c("div", { staticClass: "card_layout" }, [
                _c("section", [
                  _c("p", [_vm._v(_vm._s(item.titulo))]),
                  _c("p", [_vm._v(_vm._s(item.subtitulo))])
                ]),
                [1, 3].includes(_vm.element)
                  ? _c(
                      "figure",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "modal-options__icon icon_eye",
                            on: {
                              click: function($event) {
                                return _vm.toggleUrl(
                                  item.url,
                                  true,
                                  item.titulo
                                )
                              }
                            }
                          },
                          [_vm._v("\n            visibility\n          ")]
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.url,
                              download: "",
                              target: "_blank"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleUrl(item.url, false)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "modal-options__icon" },
                              [_vm._v("download")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c("figure", [
                      _c(
                        "a",
                        { attrs: { href: item.url, target: "_blank" } },
                        [
                          _c("v-icon", { staticClass: "modal-options__icon" }, [
                            _vm._v("play_circle_outline")
                          ])
                        ],
                        1
                      )
                    ])
              ])
            ])
          }),
          _vm.dialog
            ? _c("ModalViewPDF", {
                attrs: { url: _vm.url, title: _vm.title },
                on: { cerrar: _vm.toggleUrl }
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }